import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';

export default function ContactBlock() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });
    const [submitted, setSubmitted] = useState(false);
    const [focusedField, setFocusedField] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
        setTimeout(() => {
            setSubmitted(false);
            setFormData({ name: '', email: '', phone: '', message: '' });
        }, 3000);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
        <div className="min-h-screen py-24 relative overflow-hidden">
            <div className="absolute top-20 left-10 w-72 h-72 bg-accent/10 rounded-full blur-3xl animate-pulse"></div>
            <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
            <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-accent/5 rounded-full blur-3xl"></div>

            <div className="container mx-auto relative z-10">
                <div className="text-center mb-16">
                    <div className="flex justify-center mb-6 relative">
                        <div className="absolute inset-0 bg-gradient-to-r from-accent/20 to-accent/10 blur-2xl animate-pulse"></div>
                    </div>
                    <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 tracking-tight">
                        <span className="bg-gradient-to-r from-accent to-accent/80 bg-clip-text text-transparent">
                            Свяжитесь с нами
                        </span>
                    </h1>
                    <p className="text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed">
                        Профессиональное фотооборудование для создания идеальных снимков.
                        Мы всегда рады помочь вам с выбором
                    </p>
                </div>

                <div className="grid lg:grid-cols-5 gap-8">
                    <div className="lg:col-span-2 space-y-6">
                        <div className="bg-gradient-to-br from-[#2a2a2a] to-[#1f1f1f] rounded-3xl p-8 border border-white/10 backdrop-blur-sm relative overflow-hidden group hover:border-accent/30 transition-all duration-500">
                            <div className="absolute inset-0 bg-gradient-to-br from-accent/0 to-accent/0 group-hover:from-accent/5 group-hover:to-accent/5 transition-all duration-500"></div>
                            <h2 className="text-2xl font-bold text-white mb-8 relative">
                                Наши контакты
                            </h2>

                            <div className="space-y-6 relative">
                                <div className="flex items-start gap-4 group/item">
                                    <div className="bg-gradient-to-br from-accent/10 to-accent/5 p-4 rounded-xl border border-accent/20 group-hover/item:scale-110 transition-transform duration-300">
                                        <Phone className="w-6 h-6 text-accent" />
                                    </div>
                                    <div>
                                        <h3 className="text-white font-semibold mb-2 text-sm uppercase tracking-wide">Телефон</h3>
                                        <p className="text-gray-400 hover:text-accent transition-colors cursor-pointer">+998 90 960 12 01</p>
                                        <p className="text-gray-400 hover:text-accent transition-colors cursor-pointer">+998 90 908 32 26</p>
                                    </div>
                                </div>

                                <div className="flex items-start gap-4 group/item">
                                    <div className="bg-gradient-to-br from-accent/10 to-accent/5 p-4 rounded-xl border border-accent/20 group-hover/item:scale-110 transition-transform duration-300">
                                        <Mail className="w-6 h-6 text-accent" />
                                    </div>
                                    <div>
                                        <h3 className="text-white font-semibold mb-2 text-sm uppercase tracking-wide">Email</h3>
                                        <p className="text-gray-400 hover:text-accent transition-colors cursor-pointer">info@max-photo.uz</p>
                                    </div>
                                </div>

                                <div className="flex items-start gap-4 group/item">
                                    <div className="bg-gradient-to-br from-accent/10 to-accent/5 p-4 rounded-xl border border-accent/20 group-hover/item:scale-110 transition-transform duration-300">
                                        <MapPin className="w-6 h-6 text-accent" />
                                    </div>
                                    <div>
                                        <h3 className="text-white font-semibold mb-2 text-sm uppercase tracking-wide">Адрес</h3>
                                        <p className="text-gray-400 leading-relaxed">
                                            Ташкент, Узбекистан<br />
                                            Торговый комплекс Малика
                                        </p>
                                    </div>
                                </div>

                                <div className="flex items-start gap-4 group/item">
                                    <div className="bg-gradient-to-br from-accent/10 to-accent/5 p-4 rounded-xl border border-accent/20 group-hover/item:scale-110 transition-transform duration-300">
                                        <Clock className="w-6 h-6 text-accent" />
                                    </div>
                                    <div>
                                        <h3 className="text-white font-semibold mb-2 text-sm uppercase tracking-wide">Режим работы</h3>
                                        <p className="text-gray-400">C 9:00 - до 19:00</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-gradient-to-br from-accent/10 via-accent/5 to-accent/10 rounded-3xl p-8 border border-accent/20 backdrop-blur-sm relative overflow-hidden">
                            <div className="absolute top-0 right-0 w-32 h-32 bg-accent/20 rounded-full blur-3xl"></div>
                            <h3 className="text-xl font-bold text-white mb-6 relative">Почему выбирают нас?</h3>
                            <div className="grid grid-cols-2 gap-4 relative">
                                <div className="text-center">
                                    <div className="text-3xl font-bold bg-gradient-to-r from-accent to-accent/80 bg-clip-text text-transparent mb-1">15+</div>
                                    <div className="text-xs text-gray-400">лет опыта</div>
                                </div>
                                <div className="text-center">
                                    <div className="text-3xl font-bold bg-gradient-to-r from-accent to-accent/80 bg-clip-text text-transparent mb-1">500+</div>
                                    <div className="text-xs text-gray-400">клиентов</div>
                                </div>
                                <div className="text-center">
                                    <div className="text-3xl font-bold bg-gradient-to-r from-accent to-accent/80 bg-clip-text text-transparent mb-1">24/7</div>
                                    <div className="text-xs text-gray-400">поддержка</div>
                                </div>
                                <div className="text-center">
                                    <div className="text-3xl font-bold bg-gradient-to-r from-accent to-accent/80 bg-clip-text text-transparent mb-1">100%</div>
                                    <div className="text-xs text-gray-400">гарантия</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="bg-gradient-to-br from-[#2a2a2a] to-[#1f1f1f] rounded-3xl p-10 border border-white/10 backdrop-blur-sm relative overflow-hidden h-full">
                            <div className="absolute inset-0 bg-gradient-to-tr from-accent/5 via-transparent to-accent/5"></div>

                            <div className="relative">
                                <h2 className="text-3xl font-bold text-white mb-3">Напишите нам</h2>
                                <p className="text-gray-400 mb-8">Заполните форму и мы свяжемся с вами в ближайшее время</p>

                                {submitted ? (
                                    <div className="bg-gradient-to-br from-accent/10 to-accent/10 border border-accent/20 rounded-2xl p-10 text-center backdrop-blur-sm">
                                        <div className="w-20 h-20 bg-gradient-to-br from-accent/20 to-accent/20 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
                                            <Send className="w-10 h-10 text-accent" />
                                        </div>
                                        <h3 className="text-2xl font-bold text-white mb-3">Спасибо за обращение!</h3>
                                        <p className="text-gray-400">Ваше сообщение успешно отправлено. Мы свяжемся с вами в ближайшее время.</p>
                                    </div>
                                ) : (
                                    <div className="space-y-6">
                                        <div className="grid md:grid-cols-2 gap-6">
                                            <div>
                                                <label className="block text-gray-300 font-medium mb-3 text-sm uppercase tracking-wide">
                                                    Ваше имя *
                                                </label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    onFocus={() => setFocusedField('name')}
                                                    onBlur={() => setFocusedField(null)}
                                                    required
                                                    className={`w-full bg-[#1a1a1a] border ${focusedField === 'name' ? 'border-accent shadow-lg shadow-accent/20' : 'border-white/10'} rounded-xl px-5 py-4 text-white placeholder-gray-500 focus:outline-none transition-all duration-300`}
                                                    placeholder="Введите ваше имя"
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-gray-300 font-medium mb-3 text-sm uppercase tracking-wide">
                                                    Телефон *
                                                </label>
                                                <input
                                                    type="tel"
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    onFocus={() => setFocusedField('phone')}
                                                    onBlur={() => setFocusedField(null)}
                                                    required
                                                    className={`w-full bg-[#1a1a1a] border ${focusedField === 'phone' ? 'border-accent shadow-lg shadow-accent/20' : 'border-white/10'} rounded-xl px-5 py-4 text-white placeholder-gray-500 focus:outline-none transition-all duration-300`}
                                                    placeholder="+998 90 123 45 67"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-gray-300 font-medium mb-3 text-sm uppercase tracking-wide">
                                                Email *
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                onFocus={() => setFocusedField('email')}
                                                onBlur={() => setFocusedField(null)}
                                                required
                                                className={`w-full bg-[#1a1a1a] border ${focusedField === 'email' ? 'border-accent shadow-lg shadow-accent/20' : 'border-white/10'} rounded-xl px-5 py-4 text-white placeholder-gray-500 focus:outline-none transition-all duration-300`}
                                                placeholder="your@email.com"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-gray-300 font-medium mb-3 text-sm uppercase tracking-wide">
                                                Сообщение *
                                            </label>
                                            <textarea
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                onFocus={() => setFocusedField('message')}
                                                onBlur={() => setFocusedField(null)}
                                                required
                                                rows="5"
                                                className={`w-full bg-[#1a1a1a] border ${focusedField === 'message' ? 'border-accent shadow-lg shadow-accent/20' : 'border-white/10'} rounded-xl px-5 py-4 text-white placeholder-gray-500 focus:outline-none transition-all duration-300 resize-none`}
                                                placeholder="Расскажите нам о вашем запросе..."
                                            ></textarea>
                                        </div>

                                        <button
                                            onClick={handleSubmit}
                                            className="w-full bg-gradient-to-r from-accent to-accent/90 hover:from-accent/90 hover:to-accent text-white font-semibold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-accent/30 flex items-center justify-center gap-3 group relative overflow-hidden"
                                        >
                                            <span className="absolute inset-0 bg-gradient-to-r from-accent/90 to-accent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                            <span className="relative flex items-center gap-3">
                                                <Send className="w-5 h-5 group-hover:rotate-45 transition-transform duration-300" />
                                                Отправить сообщение
                                            </span>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}